// Copyright (c) 2023 embyt GmbH. All rights reserved.
// Author: Marc Planeck

import * as React from "react";
import { connect } from "react-redux";
import { WrappedComponentProps, injectIntl } from "react-intl";

import { IAction } from "actions";
import { isSet } from "utils";
import { MainPanel } from "types";
import { IState } from "states/states";
import { IRfid } from "states/ocppstates";

import RfidList from "./RfidList";
import RfidStatistics from "view/comp/RfidStatistics";

const MAX_CARDS = 3;
interface IRfidWidgetProps {
  isRfidDetail: boolean;
  rfids: IRfid[];
  totalCardsCharging: number;
}

const mapStateToProps = (state: IState) => {
  const totalCardsCharging = state.ocpp.rfid.reduce((prev, curRfid, curIndex) => {
    const pendingSession = state.ocpp.pendingChargingSession.find(
      (curItem) => curItem.rfid === curRfid.rfid,
    );
    return prev + (isSet(pendingSession) ? 1 : 0);
  }, 0);

  const props: IRfidWidgetProps = {
    isRfidDetail: state.router.panel === MainPanel.RFIDDETAIL,
    rfids: state.ocpp.rfid,
    totalCardsCharging,
  };
  return props;
};

interface IRfidWidgetState {}

interface IRfidWidgetDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IRfidWidgetDispatch = {};
  return dispatchProps;
};

class RfidWidgetComponent extends React.Component<
  IRfidWidgetProps & IRfidWidgetDispatch & WrappedComponentProps,
  IRfidWidgetState
> {
  public render() {
    return (
      <>
        <div id="rfidpage">{this.renderWidget()}</div>
      </>
    );
  }

  private renderWidget() {
    return (
      <div
        id="rfidpage-widget"
        className={`d-print-none ${
          this.props.isRfidDetail ? "d-none d-md-block" : "col-12"
        } col-md-12 col-lg-12 col-xl-12`}
      >
        {this.props.rfids.length > MAX_CARDS && <RfidStatistics />}
        {(this.props.rfids.length <= MAX_CARDS || this.props.totalCardsCharging > 0) && (
          <RfidList isDashboard={true} showOnlyCharging={true} />
        )}
      </div>
    );
  }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(RfidWidgetComponent));
